import { message } from 'antd';
import { MutableRefObject } from 'react';

import { UseTranslateType } from '@/hooks/useTranslate';
import { orderPay, orderPolling } from '@/services/order';
import { getCookie } from '@/utils';
import { AIFunction } from '@/utils/const';
import { isCnArea } from '@/utils/envHelper';
import { fc_purchase_alert_expose } from '@/utils/eventlog/eventNewConfig';

import { getFeatureSource } from '../utils';
import { OrderInfo } from './usePayment';
type Channel = {
  type: 'qrcode' | string;
  data: string;
};
export type Callback = {
  success: (orderId: string, data?: any) => void;
  error: (msg: string) => void;
};

interface ChannelPayProps {
  feature: fc_purchase_alert_expose['from'];
  commodityCode: string;
  channel?: Channel;
  callback: Callback;
}
interface ChannelPollingProps {
  orderInfo: OrderInfo;
  t: UseTranslateType | undefined;
  pollPayKey: string;
  timer: MutableRefObject<NodeJS.Timeout | null>;
  callback: { success: () => void; error: (msg: string) => void };
}

function formatParams(feature: AIFunction, commodityCode: string, channel?: Channel) {
  return {
    extend: JSON.stringify({
      uid: getCookie('user').uid,
      source: getFeatureSource(feature),
    }),
    channel: !isCnArea ? 'stripe' : channel?.data,
    country: isCnArea ? 'CN' : 'US',
    returnUrl: 'https://falcocut.ai/payTransform',
    commodityCode: String(commodityCode),
    supportDistribution: false,
  };
}
export const channelPay = async ({
  feature = AIFunction.Other,
  commodityCode,
  callback,
  channel,
}: ChannelPayProps) => {
  try {
    const params = formatParams(feature, commodityCode, channel);
    const { data, success, message: msg } = await orderPay(params);
    if (!success) {
      callback.error(msg || '/rest/dlt/commerce/prepayment callback error');
    } else {
      callback.success(data.orderId, { url: data.codeUrl });
      if (channel?.type === 'qrcode') {
        return data.codeUrl;
      } else {
        // const paymentWindow = window.open('', '_blank');
        // paymentWindow?.document.write(
        //   '<html><head><title>支付宝支付</title></head><body>' +
        //     data.codeUrl +
        //     '</body></html>',
        // );
        window.open(data.webUrl, '_blank');
      }
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const channelPolling = ({
  orderInfo,
  t,
  pollPayKey,
  timer,
  callback,
}: ChannelPollingProps) => {
  return new Promise<void>((resolve, reject) => {
    const poll = async (attempts: number) => {
      timer.current && clearTimeout(timer.current);
      try {
        if (attempts > 60 * 2) {
          callback.error('timeout');
          timer.current && clearTimeout(timer.current);
          return resolve();
        }

        const data = await orderPolling({ orderId: orderInfo.orderId });

        if (data.success && data.data === 'success') {
          callback.success();
          timer.current && clearTimeout(timer.current);
          return resolve();
        } else {
          timer.current = setTimeout(() => poll(attempts + 1), 2000);
          if (attempts === 60) {
            message.open({
              key: pollPayKey,
              type: 'warning',
              content: t && t('merror.sub.noresult.toast'),
              duration: 3.5,
            });
          }
        }
      } catch (error) {
        timer.current && clearTimeout(timer.current);
        callback.error((error as any).message || 'loop fail');
        return reject(error);
      }
    };
    if (!orderInfo.orderId) {
      return;
    }
    poll(0);
  });
};
